// extracted by mini-css-extract-plugin
module.exports = {"edit-modal_wrapper":"_1EBPX","edit-modal_select":"cO_eL"};